import type { LiHTMLAttributes } from 'react';
import type { MenuProps } from './Menu';
import type { MenuGroupProps } from './MenuGroup';
import type { MenuItemProps } from './MenuItem';

export interface OldMenuProps extends Omit<MenuProps, 'selected' | 'onChange' | 'onGroupOpenChange' | 'collapsible'> {
  /** @deprecated selected를 대신 사용해주세요. */
  selectedMenu?: MenuProps['selected'];
  /** @deprecated onChange를 대신 사용해주세요. */
  onClickMenu?: MenuProps['onChange'];
  /** @deprecated onGroupOpenChange를 대신 사용해주세요. */
  onMenuGroupOpenChange?: MenuProps['onGroupOpenChange'];
  /** @deprecated collapsible을 대신 사용해주세요. */
  toggleMode?: MenuProps['collapsible'];
}

export function convertOldMenuProps(props: OldMenuProps): MenuProps {
  const { selectedMenu, onClickMenu, onMenuGroupOpenChange, toggleMode, ...restProps } = props;

  return {
    ...restProps,
    selected: selectedMenu,
    onChange: onClickMenu,
    onGroupOpenChange: onMenuGroupOpenChange,
    collapsible: toggleMode,
  };
}

export interface OldMenuItemProps extends Omit<LiHTMLAttributes<HTMLLIElement>, 'onClick'> {
  /** 메뉴 아이템 unique ID */
  id: string;
  /** 메뉴 라벨 */
  label: string;
  /** @deprecated MenuGroup이 내부에서 관리하므로 삭제해주세요. */
  groupId?: string;
  /** @deprecated leftIcon을 대신 사용해주세요. */
  icon?: MenuItemProps['leftIcon'];
  /** @deprecated rightContent를 대신 사용해주세요. */
  suffix?: MenuItemProps['rightContent'];
}

export function convertOldMenuItemProps(props: OldMenuItemProps): MenuItemProps {
  const { groupId: _groupId, icon, suffix, children: _children, ...restProps } = props;

  return {
    ...restProps,
    leftIcon: icon,
    rightContent: suffix,
  };
}

export interface OldMenuGroupProps extends Omit<MenuGroupProps, 'leftIcon' | 'rightContent'> {
  /** @deprecated MenuGroup에서 사용되지 않으므로 삭제해주세요. */
  groupId?: string;
  /** @deprecated leftIcon을 대신 사용해주세요. */
  icon?: MenuGroupProps['leftIcon'];
  /** @deprecated rightContent를 대신 사용해주세요. */
  suffix?: MenuGroupProps['rightContent'];
}

export function convertOldMenuGroupProps(props: OldMenuGroupProps): MenuGroupProps {
  const { groupId: _groupId, icon, suffix, ...restProps } = props;

  return {
    ...restProps,
    leftIcon: icon,
    rightContent: suffix,
  };
}
